<template>
    <div class="select-product">
        <el-dialog :title="editId == 0 ? '添加' : '编辑'" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <div class="content">
                <div class="tabsType">
                    <el-radio-group v-model="tabsType" @change="tabsChange">
                        <el-radio-button :label="1">产品列表</el-radio-button>
                        <el-radio-button :label="2">模板下载</el-radio-button>
                        <el-radio-button :label="3">表格导入</el-radio-button>
                    </el-radio-group>
                    <el-button v-show="tabsType == 1" type="primary" @click="showCreateProduct('createProduct', 0, editId)" size="medium">添 加</el-button>
                </div>
                <div class="form" v-show="tabsType != 4">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item v-show="tabsType == 1">
                            <el-cascader
                                v-model="proVal"
                                placeholder="请选择产品类型"
                                clearable
                                @change="proTreeDataChange"
                                collapse-tags
                                :options="proTreeData"
                                :props="{ multiple: true, expandTrigger: 'hover', label: 'name', value: 'id' }"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <!-- <el-form-item v-show="tabsType == 1">
                            <el-input v-model="formInline.productId" placeholder="请输编号ID" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item v-show="tabsType == 1">
                            <el-input v-model="formInline.productName" placeholder="请输入产品名称" clearable></el-input>
                        </el-form-item>

                        <el-form-item v-show="tabsType == 2">
                            <el-cascader
                                placeholder="请选择商品分类"
                                clearable
                                @change="goodsClassifysChange"
                                collapse-tags
                                :options="GoodsClassifys"
                                :props="{ multiple: false, expandTrigger: 'hover', label: 'name', value: 'id' }"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item style="float: right" v-show="tabsType == 1">
                            <el-button type="primary" @click="onSubmit">查 询</el-button>
                            <el-button @click="reset">重 置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table" v-if="tabsType == 1">
                    <el-table v-loading="tabload" ref="multipleTable" :data="tableData" height="350" tooltip-effect="dark" style="width: 100%" stripe @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"> </el-table-column>
                        <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                        <el-table-column prop="product_name" label="产品名称" align="center" width="180px">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.product_name && scope.row.product_name.length > 10" :content="scope.row.product_name" placement="top" effect="light">
                                    <span>{{ scope.row.product_name | strFmt }}</span>
                                </el-tooltip>
                                <span v-else>{{ scope.row.product_name | strFmt }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="brand_name" label="品牌名称" align="center" width="180px"> </el-table-column>
                        <el-table-column prop="category_name" label="品牌规格" align="center" width="180px">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.spec_name && scope.row.spec_name.length > 10" :content="scope.row.spec_name | subStr" placement="top" effect="light">
                                    <span>{{ scope.row.spec_name | subStr | strFmt }}</span>
                                </el-tooltip>
                                <span v-else>{{ scope.row.spec_name | subStr | strFmt }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_url" label="URL地址" align="center" width="180px">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.product_url && scope.row.product_url.length > 10" :content="scope.row.product_url" placement="top" effect="light">
                                    <span>{{ scope.row.product_url | strFmt }}</span>
                                </el-tooltip>
                                <span v-else>{{ scope.row.product_url | strFmt }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="类型" align="center" width="180px">
                            <template slot-scope="scope">
                                {{ scope.row.type == 1 ? "普通授权" : scope.row.type == 2 ? "白名单" : "黑名单" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sale_price" label="价格" align="center" width="140px">
                            <template slot-scope="scope">
                                <p v-show="scope.row.type == 3">-</p>
                                <p v-show="scope.row.type != 3">销售价：{{ scope.row.type == 1 ? scope.row.sale_price : scope.row.white_sale_price }}</p>
                                <p v-show="scope.row.type != 3">上限价：{{ scope.row.type == 1 ? scope.row.price_top : scope.row.white_price_top }}</p>
                                <p v-show="scope.row.type != 3">下限价：{{ scope.row.type == 1 ? scope.row.price_bottom : scope.row.white_price_bottom }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="category_name" label="商品分类" align="center" width="180px"> </el-table-column>
                        <el-table-column prop="sale_type" label="销售方式" align="center" width="180px">
                            <template slot-scope="scope">
                                {{ scope.row.sale_type == 0 ? "不限" : scope.row.sale_type == 1 ? "线上" : "线下" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="white_start_time" label="有效时间" align="center" width="200px">
                            <template slot-scope="scope">
                                <div v-if="scope.row.type == 2">
                                    <p>开始：{{ scope.row.white_start_time }}</p>
                                    <p>结束：{{ scope.row.white_end_time }}</p>
                                </div>
                                <p v-else>-</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="操作" width="200px" align="center" fixed="right">
                            <template slot-scope="scope">
                                <div class="link">
                                    <el-link type="primary" @click="delProduct(scope.row.id)">删除</el-link>
                                    <el-link type="primary" @click="showCreateProduct('editProduct', scope.row.id, editId)">编辑</el-link>
                                    <el-link v-show="scope.row.type == 3" type="primary" @click="moveList(2, scope.row.id)">移为普通名单</el-link>
                                    <el-link v-show="scope.row.type == 1" type="primary" @click="moveList(5, scope.row.id)">移为白名单</el-link>
                                    <el-link v-show="scope.row.type == 1" type="primary" @click="moveList(3, scope.row.id)">移为黑名单</el-link>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="selectAll">
                        <div class="card">
                            <div class="select">
                                <el-checkbox v-model="checkbox" @change="toggleSelection(false)">全选</el-checkbox>
                                <span style="color: #409eff; margin-left: 20px">已选中 {{ multipleSelection.length }} 条</span>
                            </div>
                            <div class="btns">
                                <el-button type="danger" @click="delProduct(delIdList)" size="small">删除</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="pageList">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                            background
                        >
                        </el-pagination>
                    </div>
                </div>
                <div class="down" v-else-if="tabsType == 2">
                    <div>
                        <div v-if="temTotal > 0" class="list">
                            <div class="item" v-for="(item, index) in templateList" :key="index">
                                <div class="icon">
                                    <i class="iconfont icon-wenjianjia"></i>
                                </div>
                                <p>{{ item.name }}</p>
                                <el-button icon="el-icon-download" size="small" style="width: 100%" @click="getTMUrl(item.id)">下载文件</el-button>
                            </div>
                        </div>
                        <el-empty v-else description="暂无内容"></el-empty>
                    </div>
                    <div class="pageList">
                        <el-pagination
                            @size-change="temHandleSizeChange"
                            @current-change="temhandleCurrentChange"
                            :current-page="temPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="temTotal"
                            background
                        >
                        </el-pagination>
                    </div>
                </div>
                <div class="record" v-else-if="tabsType == 3">
                    <div class="til">
                        <p>历史记录</p>
                        <el-upload class="btn" action="" :multiple="true" :on-change="handleChange" :show-file-list="false" accept=".xls,.xlsx" :auto-upload="false">
                            <el-button :loading="disbtn" size="medium" type="primary">导入</el-button>
                        </el-upload>
                    </div>
                    <div class="list" :style="{ borderTop: recordList.length > 0 ? '1px solid #e8e8e8' : '' }">
                        <div v-if="recordList.length > 0">
                            <div class="item" v-for="(item, index) in recordList" :key="index">
                                <div class="icon"><i class="iconfont icon-wenjianjia"></i></div>
                                <p>{{ item.file_name }}</p>
                                <span class="date">{{ item.create_time }}</span>
                                <div class="link">
                                    <el-link type="primary" @click="getTMUrlOpen(item.download_url)">下载</el-link>
                                    <el-link type="danger" @click="deleteRecordFunc(item.id)">删除</el-link>
                                </div>
                            </div>
                        </div>
                        <el-empty v-else description="暂无内容"></el-empty>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button type="primary" @click="selSave" size="medium">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import config from "@/assets/config.json";
export default {
    data() {
        return {
            disbtn: false,
            checkbox: false, //全选
            tabsType: 1,
            tabload: false,
            // 分页
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            // 表单
            formInline: {
                productType: "",
                goodsClass: "",
                productName: "",
                productId: [0],
            },

            // 表格选择
            tableData: [],
            multipleSelection: [],
            // 模板下载分类
            downType: "",
            downOptions: [],
            // 产品监控删除所选id
            delIdList: "",
            templateList: [],
            // 模板分页
            offset: 0,
            limit: 10,
            temPage: 1,
            temTotal: 0,
            recordList: [],
            productIdList: [],
            editId: 0,
            proVal: [],
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 10) + "...";
                }
                return val;
            }
            return "-";
        },
        subStr(val) {
            if (val && val.length != 0) {
                return val.replace(/\[|]|\{|}/g, "");
            }
            return val;
        },
    },
    props: {
        proTreeData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        GoodsClassifys: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getRecordListFunc(1);
        this.getTemplateListFunc(1);
    },
    methods: {
        ...mapActions({
            productList: "brand/getAgencyProductList", //产品列表
            delAgencyProduct: "brand/delAgencyProduct", //删除产品
            getTemplateList: "brand/getTemplateList", //模板列表
            deleteRecord: "brand/deleteRecord", //删除
            productImport: "brand/productImport", //导入
            getRecordList: "brand/getRecordList", //历史记录
        }),
        tabsChange(val) {},
        //历史记录
        getRecordListFunc() {
            let opt = {
                token: this.getToken,
            };
            this.getRecordList(opt).then(({ data }) => {
                // console.log(data);
                if (data.code == 1) {
                    this.recordList = data.data.list;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 选择产品确定
        selSave() {
            let arr = this.tableData.map((item) => {
                return item.id;
            });
            this.$emit("selProductId", arr);
            this.dialogVisible = false;
        },
        // 导入
        handleChange(file, fileList) {
            this.disbtn = true;
            var formdata = new FormData();
            formdata.append("agencyId", this.editId);
            formdata.append("fileText", file.raw);
            formdata.append("token", this.getToken);
            this.productImport(formdata).then(({ data }) => {
                this.disbtn = false;
                if (data.code == 1) {
                    this.$message.success("上传成功！");
                    if (data.data.agencyProductId && data.data.agencyProductId.length > 0) {
                        data.data.agencyProductId.forEach((item) => {
                            this.formInline.productId.push(item);
                        });
                    }
                    this.getRecordListFunc();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 历史记录删除
        deleteRecordFunc(id) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let opt = {
                        token: this.getToken,
                        id: id,
                    };
                    this.deleteRecord(opt).then(({ data }) => {
                        // console.log(data);
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getRecordListFunc();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        showCreateProduct(str, id, agencyId) {
            this.$emit("selectProduct", str, id, agencyId);
        },
        getTMUrlOpen(url) {
            window.open(url);
        },
        // 下载模板
        getTMUrl(id) {
            window.open(`${config.brandHttps.api}/merchant/import/export?token=${this.getToken}&id=${id}`);
        },
        // 模板列表
        getTemplateListFunc() {
            let opt = {
                token: this.getToken, //必填 商户验证token
                offset: this.offset, //从第几条开始取， 0代表从第一条开始取
                limit: this.limit, //每页取多少条
                category_id: this.formInline.goodsClass,
            };
            this.getTemplateList(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.templateList = data.data.list;
                    this.temTotal = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 名单操作
        moveList(tag, id) {
            this.$emit("moveList", tag, id);
        },
        // 产品列表删除
        delProduct(id) {
            this.$confirm("此操作将删除选择的数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let opt = {
                        token: this.getToken,
                        id: id,
                    };
                    this.delAgencyProduct(opt).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        bindProductId(id) {
            this.formInline.productId.push(id);
            console.log(this.formInline.productId);
        },
        // 产品类型
        proTreeDataChange(val) {
            let arr = [];
            val.forEach((item) => {
                arr.push(Number(item[item.length - 1]));
            });
            this.formInline.productType = arr;
        },
        // 商品类型
        goodsClassifysChange(val) {
            let arr = [];
            val.forEach((item) => {
                arr.push(item[item.length - 1]);
            });
            this.formInline.goodsClass = arr.toString();
            this.getTemplateListFunc(1);
        },
        // 产品列表
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                page: tag == 1 ? tag : this.page,
                size: this.size,
                name: this.formInline.productName,
                product_category_id: this.formInline.productType,
                agency_id: this.editId,
            };
            if (this.editId == 0) {
                opt.id = this.formInline.productId;
            }
            this.productList(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 打开当前页并获取产品列表
        async bindData(id) {
            this.editId = id;
            this.getList(1);
            this.dialogVisible = true;
            try {
                if (localStorage.getItem("clear") === "true") {
                    this.$refs.multipleTable.clearSelection();
                    localStorage.setItem("clear", false);
                }
            } catch (err) {}
        },
        // 全选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                });
            } else {
                this.$refs.multipleTable.toggleAllSelection();
            }
        },
        // 产品列表选择改变
        handleSelectionChange(val) {
            this.$nextTick(() => {
                this.show();
            });
            this.multipleSelection = val;
            if (val && val.length > 0) {
                this.delIdList = val
                    .map((item) => {
                        return item.id;
                    })
                    .toString();
            }
        },
        // 修改全选状态
        show() {
            if (this.tableData.length == this.multipleSelection.length && this.tableData.length != 0) {
                this.checkbox = true;
            } else {
                this.checkbox = false;
            }
        },
        // 搜索
        onSubmit() {
            this.getList(1);
        },
        // 重置
        reset() {
            this.proVal = [];
            this.formInline = {
                productType: "",
                productName: "",
            };
            this.getList(1);
        },
        // 产品列表size改变
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        // 模板列表size改变
        temHandleSizeChange(val) {
            this.limit = val;
            this.getTemplateListFunc();
        },
        // 模板列表page改变
        temhandleCurrentChange(val) {
            this.temPage = val;
            this.offset = this.limit * (val - 1);
            this.getTemplateListFunc();
        },
        // 产品列表page改变
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        handleClose() {
            this.formInline = {
                productType: "",
                productName: "",
                productId: [0],
            };
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.select-product {
    ::v-deep .has-gutter tr th,
    ::v-deep .el-table th.el-table__cell {
        background-color: rgb(217, 236, 255) !important;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
    .tabsType {
        margin-bottom: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tag-group {
        padding-top: 10px;
        padding-bottom: 40px;
        .el-tag {
            margin-right: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
}
.link {
    a {
        margin: 0 12px;
    }
}
.el-table::before {
    display: none !important;
}
.selectAll {
    margin: 10px 0;
    .card {
        width: 100%;
        display: flex;
        background: #f2f2f2;
        align-items: center;
        padding: 10px;
        justify-content: space-between;
    }
}

::v-deep .el-dialog__body {
    padding: 10px 20px !important;
    height: 610px;
}
.down {
    .el-empty {
        width: 100%;
    }
    .pageList {
        text-align: center;
        margin-top: 20px;
    }
    .list {
        height: 400px;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        margin: 0 -12px;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        .item {
            padding: 0 12px;
            width: 106px;
            margin-bottom: 40px;
            box-sizing: content-box;
            .icon {
                width: 106px;
                height: 106px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #f3f3f3;
                border-radius: 8px;
                i {
                    font-size: 36px;
                    color: #b6b6b6;
                }
            }
            p {
                height: 32px;
                margin: 10px 0;
                text-align: center;
                line-height: 16px;
                font-size: 12px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        }
    }
}
.record {
    .til {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
    }
    .list {
        margin-top: 40px;
        max-height: 420px;
        overflow-y: scroll;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        .item {
            display: flex;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #e8e8e8;
            .icon {
                margin-right: 20px;
                border-radius: 4px;
                width: 34px;
                height: 34px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #f1f1f1;
                color: #b6b6b6;
                font-size: 24px;
            }
            p {
                margin-right: 20px;
                max-width: 240px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .date {
                margin-right: 60px;
            }
        }
    }
}
.addReg {
    .form {
        margin-bottom: 20px;
    }
}
</style>